module.exports = __webpack_public_path__ + "static/media/scblack.f01707aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/scblack.jpg
// module id = 147
// module chunks = 0